import { render, staticRenderFns } from "./TechService.vue?vue&type=template&id=69e08bca"
import script from "./TechService.vue?vue&type=script&lang=js"
export * from "./TechService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports